import * as types from "../constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities";


const initialState = {

};


function groupTemplateReducer(state = initialState, action) {
    let newState;
    let tempGroupTemplate;

    switch (action.type) {
        case types.GROUP_TEMPLATE_GET_SUCCESS:
        case types.GROUP_TEMPLATE_CREATE_SUCCESS:
        case types.GROUP_TEMPLATE_UPDATE_SUCCESS:

            return {
                ...state,
                [action.groupTemplate.templateKey]: {
                    ...action.groupTemplate
                }
            };

        // Added to add graph to editors
        case types.GROUP_GRAPH_GET_SUCCESS:
        case types.GROUP_GRAPH_CREATE_SUCCESS:
        case types.GROUP_GRAPH_UPDATE_SUCCESS:

            return {
                ...state,
                [action.groupTemplate.templateKey]: {
                    ...action.groupTemplate
                }
            };

        case types.GROUP_TEMPLATE_ADD_SHOW_GROUP_KEYS:
            //debugger; // SSSSS Show Group Testing
            newState = portalShared.cloneObj(state);

            tempGroupTemplate = newState[action.groupTemplate.templateKey];

            for (let i = 0; i < action.showGroupKeys.length; i++) {

                if (!tempGroupTemplate.showGroupKeys.includes(action.showGroupKeys[i])) {
                    tempGroupTemplate.showGroupKeys.push(action.showGroupKeys[i]);
                }

            }

            return newState;

        case types.GROUP_TEMPLATE_ADD_QUESTION_KEY:

            newState = portalShared.cloneObj(state);

            tempGroupTemplate = newState[action.groupTemplate.templateKey];

            if (!tempGroupTemplate.questionKeys.includes(action.questionKey)) {
                tempGroupTemplate.questionKeys.push(action.questionKey);
            }

            return newState;

        case types.GROUP_TEMPLATE_SET_SHOW_GROUP_KEYS:
            //debugger; // SSSSS Show Group Testing
            newState = portalShared.cloneObj(state);

            tempGroupTemplate = newState[action.groupTemplate.templateKey];

            tempGroupTemplate.questionKeys = tempGroupTemplate.questionKeys.filter(key => key !== action.removedQuestionKey);

            tempGroupTemplate.showGroupKeys = action.showGroupKeys;

            return newState;

        default:
            return state;
    }
}

export default groupTemplateReducer;